<template>
    <div class="school-and-date unit" :class="onlyOneTitle ? 'only-one' : ''">
        <span>{{ displaySchoolName }}</span>
        <span :class="onlyOneTitle ? 'only-one' : ''">{{ onlyOneTitle }}</span>
        <span>{{ dateTime || '' }}</span>
    </div>
</template>
<script>
import { handleDeptName } from "@/assets/js/mock";
import { TAB_MAP_VALUE, SPECIAL_ONE } from "@/assets/js/constants";
const { getDisplaySchoolName } = require("@/assets/js/schoolAndDateDisplay");
export default {
    name: 'schoolAndDate',
    props: {
        schoolName: {
            type: String,
            default: '',
        },
        dateTime: {
            type: String,
            default: '',
        },
    },
    computed: {
        displaySchoolName() {
            return getDisplaySchoolName({
                querySchoolName: this.querySchoolName,
                schoolName: this.schoolName,
                formatSchoolName: this.handleDeptName,
            })
        }
    },
    watch: {
        $route: {
            deep: true,
            immediate: true,
            handler(to) {
                console.log('===> 组件schoolAndDate 监听route <==', to)
                this.handleOnlyOneLayout(to.query)
            },
        }
    },
    data() {
        return {
            // 只有一个标题的样式排版
            onlyOneTitle: '',
            querySchoolName: '',
        }
    },
    mounted() { },
    methods: {
        handleDeptName,
        handleOnlyOneLayout(query = {}) {

            try {
                const { item = '', onlyOne, schoolName = '' } = query
                const itemArr = item ? item.split(',') : []
                this.querySchoolName = schoolName
                if (itemArr.length === 1) {
                    this.onlyOneTitle = TAB_MAP_VALUE[item] || ''
                } else {
                    this.onlyOneTitle = ''
                }

                if (onlyOne === '1' || [SPECIAL_ONE].includes(itemArr[0])) {
                    this.onlyOneTitle = ''
                }

            } catch (error) {
                this.onlyOneTitle = ''
                this.querySchoolName = ''
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.unit {
    position: absolute;
    left: 0;
    right: 0;
    top: vh(-30);
    margin: auto;
    width: 100%;
    color: #FFF;
    font-size: vh(16);
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
    align-items: center;

    &.only-one {
        position: static;
        margin: vh(-20) auto 0;
        padding: vh(20) 0 vh(30);
        background-color: #00048f;
    }

    >span {
        display: block;
        min-width: 0;
        color: #3CEAFF;
        font-weight: 100;
    }

    >span:nth-of-type(1) {
        text-align: left;
        white-space: normal;
        word-break: break-all;
        overflow-wrap: anywhere;
        line-height: 1.4;
    }

    >span:nth-of-type(2) {
        font-size: 0;
        font-weight: bold;
        color: #3CEAFF;
        justify-self: center;
        text-align: center;
        padding: 0 vh(12);

        &.only-one {
            font-size: vh(30);
        }
    }

    >span:nth-of-type(3) {
        text-align: right;
        white-space: normal;
        word-break: break-all;
        overflow-wrap: anywhere;
        line-height: 1.4;
    }

}
</style>
